import { render, staticRenderFns } from "./SettingsStep.vue?vue&type=template&id=14b1f758&scoped=true"
import script from "./SettingsStep.vue?vue&type=script&lang=js"
export * from "./SettingsStep.vue?vue&type=script&lang=js"
import style0 from "./SettingsStep.vue?vue&type=style&index=0&id=14b1f758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b1f758",
  null
  
)

export default component.exports